import { render, staticRenderFns } from "./OtpTab.vue?vue&type=template&id=0d1915dc"
import script from "./OtpTab.vue?vue&type=script&lang=js"
export * from "./OtpTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports